module.exports = __webpack_public_path__ + "static/media/symptomsicon_belching_or_burping_uni.4a20c3f3.svg";